const actionTypes = {
  SET_MODAL_FILE_ADDITION_ACTIVE_STATUS: 'setModalFileAdditionActiveStatus',
  SET_MODAL_PRODUCT_RELATION_ACTIVE_STATUS: 'setModalProductRelationActiveStatus',

  SET_DOCUMENT_ITEM: 'setOriginalDocumentItem',
  SET_COMPARE_DOCUMENT_ITEM: 'setCompareDocumentItem',
  CLEAR_DOCUMENT_ITEM: 'clearDocumentItem',

  SET_REMARK: 'setDocumentDetailRemark',
  REVERT_REMARK: 'revertDocumentDetailRemark',
  SET_REMARK_ERROR: 'setDocumentDetailRemarkError',

  SET_FILE_LIST: 'setFileList',
  REVERT_FILE_LIST: 'revertFileList',
  DELETE_FILE: 'deleteFile',

  SET_SELECTED_FILE: 'setSelectedFile',
  SET_SELECTED_FILE_ERROR: 'setSelectedFileError',
  SET_SELECT_FILE_UNDER_ERROR: 'setSelectFileUnderError',
  SET_NEW_FILE_REVISION_DATE: 'setNewFileRevisionDate',
  SET_NEW_FILE_REVISION_DATE_ERROR: 'setNewFileRevisionDateError',

  SET_PREPARE_UPLOAD_FILES: 'setPrepareUploadFiles',

  SET_FORM_UPDATE_STATUS: 'documentDetailSetFormUpdateStatus',

  SET_SORT_INFO: 'setSortInfo',
  SET_UPLOAD_FILE_TYPE: 'setUploadFileType',

  SET_OCR_DATA_ITEM: 'setOriginalOcrDataItem',
  SET_COMPARE_OCR_DATA_ITEM: 'setCompareOcrDataItem',
  REVERT_OCR_DATA_ITEM: 'revertOcrDataItem',
  SET_OCR_UPDATE_MESSAGE: 'setOcrUpdateMessage',
}

export default actionTypes
